import axiosClient from './axiosClient';

export const fetchHighlights = async () => {
    try {
        const response = await axiosClient.get('/v1/youtube-videos');
        if (response.data && response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.errors || 'Failed to fetch highlights');
        }
    } catch (error) {
        throw error;
    }
}; 

export const fetchGameHighlights = async () => {
    try {
        const response = await axiosClient.get('/v1/youtube-videos/games');
        if (response.data && response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.errors || 'Failed to fetch game highlights');
        }
    } catch (error) {
        throw error;
    }
}; 

export const fetchGameVideos = async (gameId) => {
    try {
        const response = await axiosClient.post('/v1/youtube-videos/game-videos', { gameId });
        if (response.data && response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.errors || 'Failed to fetch game videos');
        }
    } catch (error) {
        throw error;
    }
};